import { render, staticRenderFns } from "./workshop-infos.vue?vue&type=template&id=1f51b4aa"
import script from "./workshop-infos.vue?vue&type=script&lang=ts"
export * from "./workshop-infos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports